import audConfig from "~/aud.config";


export default (_, inject) => {
  inject('aud', audConfig);
};
